import { SEARCH_PARAMS_INTERNAL } from '../constants/auth';
import { AUTH_TYPE } from '../types/auth';
import { equalsIgnoreCase } from '../utils/stringUtils';

const useGetConnectionType = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const connectionType = searchParams.get(SEARCH_PARAMS_INTERNAL) || searchParams.get('connect');

  return equalsIgnoreCase(connectionType, AUTH_TYPE.Internal) ? AUTH_TYPE.Internal : AUTH_TYPE.External;
};

export default useGetConnectionType;
